export const management = {
  routes: [
    {
      path: "/management/transfer-library",
      component: () => import("../management-transfer-library-view"),
    },
  ],
};
